import { createSlice, Draft, PayloadAction } from "@reduxjs/toolkit";

interface InitialState {
  queryAnalysisData: any;
  isLoading:boolean;
}

const initialState: InitialState = {
  queryAnalysisData: [],
  isLoading:false,
};

const newGrafanaSlice = createSlice({
  name: "newGrafana",
  initialState,
  reducers: {
    setQueryAnalysisData: (
      state: Draft<InitialState>,
      action: PayloadAction<any>
    ) => ({
      ...state,
      queryAnalysisData: action.payload,
    }),
    setLoader: (state: Draft<InitialState>, action: PayloadAction<any>) => {
      return {
        ...state,
        isLoading: action.payload,
      }
    },
  },
});

export const { setQueryAnalysisData, setLoader } = newGrafanaSlice.actions;

export default newGrafanaSlice.reducer;
